import React from 'react';
import FadeIn from '../animations/FadeIn';
import PaperformEmbed from '../PaperformEmbed';

export default function EmbedPaperform({
  title,
  subtitle,
  description,
  paperform_id,
  bgColor = 'transparent',
  paddingTop = '0',
  paddingBottom = '0',
}) {
  return paperform_id ? (
    <div className="max-width">
      <div className="py-10 lg:py-32">
        <div className="mx-auto my-0 text-center whitespace-pre-line">
          {title && (
            <h2 className="text-[2.25rem] leading-[1.2] mx-auto max-w-3xl">
              {title}
            </h2>
          )}
          {subtitle && (
            <h3 className="text-[1.2rem] leading-[1.6] font-light mx-auto max-w-3xl lg:px-10">
              {subtitle}
            </h3>
          )}
          {description && (
            <p className="text-[0.9rem] leading-[1.6] mt-[3rem] mb-[1.5rem] mx-auto max-w-3xl lg:px-10">
              {description}
            </p>
          )}
        </div>

        <div className="my-0 mx-auto max-w-5xl">
          <FadeIn>
            <PaperformEmbed
              paperformID={paperform_id}
              isRounded
              bgColor={bgColor}
              paddingTop={paddingTop}
              paddingBottom={paddingBottom}
            />
          </FadeIn>
        </div>
      </div>
    </div>
  ) : null;
}
